import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LocaleContext = createContext({
  locale: 'fi',
  setLocale: () => {},
});

const STORAGE_KEY = 'tuutorikeskus:locale';

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    if (typeof window === 'undefined') {
      return 'fi';
    }
    return window.localStorage.getItem(STORAGE_KEY) || 'fi';
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, locale);
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [locale]
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => useContext(LocaleContext);






